export default "__VITE_ASSET__D$maHmhX__"